import React from "react";
import { Link } from "react-router-dom";

const MaintenanceLoader = () => {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
      {[...Array(9)].map((_, i) => (
        <div
          key={i}
          className="add-post-container add-cart"
          style={{ width: "33.33%" }}
        >
          <div className="add-cart-post new spa ">
            <div className="add-cart-post-inner">
              <div className="animated-background bg-skimmer"></div>
              <span className="img-pnl navigate">
                <img src="" />
              </span>
              <div className="txt-pnl navigate">
                <h2></h2>
                <p></p>
                <div className="flex-div align-item-center">
                  <h3></h3>
                  {/* <Link to="" className="reg-btn service"></Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MaintenanceLoader;
